var map = {
	"./01/revolution sonu nigam poster.png": 720,
	"./02/sagar wali qawwali.png": 111,
	"./03/SuperHit Tour Vishal & Sheykhar.jpg": 503,
	"./04/Unikick poster.webp": 199,
	"./05/USA Tour Jubin N.png": 848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 874;